import { useAtomValue } from 'jotai';
import { unwrappedNavigationGameIdAtom } from '@/atoms/navigation';
import { MATCH_BASE_ROUTE } from '@/utils/classicLinks';

export const useMatchRoute = () => {
  const iqGameId = useAtomValue(unwrappedNavigationGameIdAtom);
  return `${MATCH_BASE_ROUTE}/${iqGameId}`;
};
